export default {
  slug: 'keyboard-shortcuts',
  title: 'Keyboard shortcuts',
  description: 'Command palette, graph, and navigation keys.',
  section: 'reference',
  order: 1,
  tags: ['shortcuts', 'keyboard', 'palette'],
  body: `# Keyboard shortcuts

## Global

| Shortcut | Action |
|----------|--------|
| **⌘K** / **Ctrl+K** | Open command palette |
| **Esc** | Close modals, graph overlay, command palette |

## Command palette

Type to filter routes by name, section, or path. Press **Enter** to navigate.

Documentation pages are indexed — search "graph", "cases", or "extractor" to jump here or to live modules.

## Investigation graph

| Shortcut | Action |
|----------|--------|
| **Esc** | Close graph |
| **Backspace** | Go back to previous graph focus |
| **Enter** | Open selected entity (when selection panel visible) |

## Wiki

| Shortcut | Action |
|----------|--------|
| **/** | Focus wiki search (when on a docs page) |

## Evidence timestamps

Use the timezone toggle on case/evidence views to switch between UTC and local analyst time — preference persists per session.
`,
};
